<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Alarm Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current alarm profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Alarm Profile Config'" style="height: 410px">
          <!--配置按钮-->
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkAdd()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <!--显示列表-->
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAllAlarm"
                  />
                  <label for="idSelectAllAlarm"></label>
                </th>
                <th
                  v-for="(value, key) in alarmProfileTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in alarmProfileTable.data"
                :key="row.profileid"
                :class="{ 'true:': true }"
              >
                <td width="40px">
                  <div v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelectAlarm' + index"
                    />
                    <label :for="'idRowSelectAlarm' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileid }}</div>
                </td>
                <td>
                  <div>{{ row.name }}</div>
                </td>
                <td>
                  <div>{{ row.rxlow }}</div>
                </td>
                <td>
                  <div>{{ row.rxhigh }}</div>
                </td>
                <td>
                  <div>{{ row.txlow }}</div>
                </td>
                <td>
                  <div>{{ row.txhigh }}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <!--配置窗口-->
          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Alarm Profile Edit'"
              @close="isShowAddTable = false"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId"
                    >Profile ID</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{ 'has-error': checkProfileID() }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      :disabled="isEditClik"
                      v-model="alarmForm.profileid"
                      placeholder="INTEGER<0-127>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkProfileID() ? 'block' : 'none',
                      }"
                      >{{ checkProfileID() }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name"
                    >Profile Name</label
                  >
                  <div class="col-sm-5" :class="{ 'has-error': checkName() }">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      v-model="alarmForm.name"
                      placeholder="STRING<1-128>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkName() ? 'block' : 'none',
                      }"
                      >{{ checkName() }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="rxlow"
                    >Rx Low</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters('rx', alarmForm.rxlow),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="rxlow"
                      v-model="alarmForm.rxlow"
                      placeholder="-127.0 ~ 0.0(dBm)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters('rx', alarmForm.rxlow)
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("rx", alarmForm.rxlow) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="rxhigh"
                    >Rx High</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters('rx', alarmForm.rxhigh),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="rxhigh"
                      v-model="alarmForm.rxhigh"
                      placeholder="-127.0 ~ 0.0(dBm)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters('rx', alarmForm.rxhigh)
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("rx", alarmForm.rxhigh) }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="txlow"
                    >Tx Low</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters('tx', alarmForm.txlow),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="txlow"
                      v-model="alarmForm.txlow"
                      placeholder="0.0 ~ 127.0(dBm)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters('tx', alarmForm.txlow)
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("tx", alarmForm.txlow) }}
                    </small>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="txhigh"
                    >Tx High</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters('tx', alarmForm.txhigh),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="txhigh"
                      v-model="alarmForm.txhigh"
                      placeholder="0.0 ~ 127.0(dBm)"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters('tx', alarmForm.txhigh)
                          ? 'block'
                          : 'none',
                      }"
                      >{{ checkParameters("tx", alarmForm.txhigh) }}
                    </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileAlarm",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      alarmForm: {
        profileid: "",
        name: "",
        rxlow: "",
        rxhigh: "",
        txlow: "",
        txhigh: "",
      },
      alarmProfileTable: "",
    }
  },
  created() {
    this.loadAlarmProfile()
  },
  methods: {
    loadAlarmProfile() {
      get("alarmProfile")
        .then((res) => (this.alarmProfileTable = res.data))
        .catch((err) => {
          this.alarmProfileTable = en.alarmProfileTable
        })
    },

    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },

    clkEdit() {
      for (let i = 0; i < this.alarmProfileTable.data.length; i++) {
        if (this.alarmProfileTable.data[i].selected) {
          this.alarmForm.profileid = this.alarmProfileTable.data[i].profileid
          if (this.alarmProfileTable.data[i].name.match(/^INDEX_/) == null) {
            this.alarmForm.name = this.alarmProfileTable.data[i].name
          }
          this.alarmForm.rxlow = this.alarmProfileTable.data[i].rxlow
          this.alarmForm.rxhigh = this.alarmProfileTable.data[i].rxhigh
          this.alarmForm.txlow = this.alarmProfileTable.data[i].txlow
          this.alarmForm.txhigh = this.alarmProfileTable.data[i].txhigh
          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.alarmProfileTable.data.length; i++) {
        if (this.alarmProfileTable.data[i].selected) {
          list.push({ aim: Number(this.alarmProfileTable.data[i].profileid) })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["profileList"] = list
      post("alarmProfileDelete", delData)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadAlarmProfile()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else {
            this.loadAlarmProfile()
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    clkCancel() {
      this.isShowAddTable = false
      console.log(this.isShowAddTable)
    },

    resetField() {
      var alarmFormTmp = {
        profileid: "",
        name: "",
        rxlow: "",
        rxhigh: "",
        txlow: "",
        txhigh: "",
      }
      this.alarmForm = alarmFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.alarmProfileTable.data.length; i++) {
        if (this.isSelectAll) {
          this.alarmProfileTable.data[i].selected = true
        } else {
          this.alarmProfileTable.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.alarmProfileTable.data.length; i++) {
        this.alarmProfileTable.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var alarmProfile = {
        profileid: Number(this.alarmForm.profileid),
        name: this.alarmForm.name,
        rxlow: Math.abs(Number(this.alarmForm.rxlow) * 2),
        rxhigh: Math.abs(Number(this.alarmForm.rxhigh) * 2),
        txlow: Number(this.alarmForm.txlow) * 2,
        txhigh: Number(this.alarmForm.txhigh) * 2,
      }

      if (this.isEditClik == false) {
        for (let i = 0; i < this.alarmProfileTable.data.length; i++) {
          if (
            alarmProfile.profileid == this.alarmProfileTable.data[i].profileid
          ) {
            this.showAlertBox(
              "warn",
              "Message",
              "This profile ID has been created"
            )
            return
          }
        }
      }

      if (this.alarmForm.profileid == "" || this.checkProfileID()) {
        this.showAlertBox("warn", "Message", "Invalid profileID")
        return
      }
      if (this.alarmForm.name.length > 128 || this.checkName()) {
        this.showAlertBox("warn", "Message", "Invalid name")
        return
      }
      if (
        this.alarmForm.rxlow != "" &&
        (Number(this.alarmForm.rxlow) > 0 ||
          Number(this.alarmForm.rxlow) < -127)
      ) {
        this.showAlertBox("warn", "Message", "Invalid rxlow")
        return
      }
      if (
        this.alarmForm.rxhigh != "" &&
        (Number(this.alarmForm.rxhigh) > 0 ||
          Number(this.alarmForm.rxhigh) < -127)
      ) {
        this.showAlertBox("warn", "Message", "Invalid rxhigh")
        return
      }
      if (
        this.alarmForm.txlow != "" &&
        (Number(this.alarmForm.txlow) < 0 || Number(this.alarmForm.txlow) > 127)
      ) {
        this.showAlertBox("warn", "Message", "Invalid txlow")
        return
      }
      if (
        this.alarmForm.txhigh != "" &&
        (Number(this.alarmForm.txhigh) < 0 ||
          Number(this.alarmForm.txhigh) > 127)
      ) {
        this.showAlertBox("warn", "Message", "Invalid txhigh")
        return
      }

      if (this.alarmForm.rxlow == "") {
        alarmProfile.rxlow = 0xff
      }
      if (this.alarmForm.rxhigh == "") {
        alarmProfile.rxhigh = 0xff
      }
      if (this.alarmForm.txlow == "") {
        alarmProfile.txlow = 0xff
      }
      if (this.alarmForm.txhigh == "") {
        alarmProfile.txhigh = 0xff
      }

      post("alarmProfileConfig", alarmProfile)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadAlarmProfile()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else {
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
      this.selectNull()
    },
    checkProfileID() {
      if (this.alarmForm.profileid != "") {
        let profileID = Number(this.alarmForm.profileid)
        if (!isNaN(profileID)) {
          if (profileID < 0 || profileID > 127)
            return "profile ID must be in range 0-127"
        } else return "profile ID must be in range 0-127"
      }
      return null
    },
    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "rx") {
        if (isNaN(Number(value)) || Number(value) < -127 || Number(value) > 0) {
          return "value must be in range -127-0"
        }
      }
      if (type == "tx") {
        if (isNaN(Number(value)) || Number(value) < 0 || Number(value) > 127) {
          return "value must be in range 0-127"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
    checkName() {
      if (nonASCIIchar(this.alarmForm.name)) {
        return nonASCIIchar(this.alarmForm.name)
      }
      if (this.alarmForm.name.split(" ").length > 1) {
        return "invalid name"
      }
      return null
    },
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>